export { TutorApplicationRecordingPage } from "./TutorApplicationRecordingPage"
export type { TutorApplicationRecordingPageProps } from "./TutorApplicationRecordingPage"
